"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;
var _default = (s, t) => {
  t.prototype.isBusinessDay = function () {
    return !![1, 2, 3, 4, 5].includes(this.day());
  }, t.prototype.businessDaysAdd = function (s) {
    const t = s < 0 ? -1 : 1;
    let e = this.clone(),
      n = Math.abs(s);
    for (; n > 0;) e = e.add(t, "d"), e.isBusinessDay() && (n -= 1);
    return e;
  }, t.prototype.businessDaysSubtract = function (s) {
    let t = this.clone();
    return t = t.businessDaysAdd(-1 * s), t;
  }, t.prototype.businessDiff = function (s) {
    const t = this.clone(),
      e = s.clone(),
      n = t >= e;
    let o = n ? e : t;
    const i = n ? t : e;
    let r = 0;
    if (o.isSame(i)) return r;
    for (; o < i;) o.isBusinessDay() && (r += 1), o = o.add(1, "d");
    return n ? r : -r;
  }, t.prototype.nextBusinessDay = function () {
    let s = this.clone(),
      t = 1;
    for (; t < 7 && (s = s.add(1, "day"), !s.isBusinessDay());) t += 1;
    return s;
  }, t.prototype.prevBusinessDay = function () {
    let s = this.clone(),
      t = 1;
    for (; t < 7 && (s = s.subtract(1, "day"), !s.isBusinessDay());) t += 1;
    return s;
  }, t.prototype.businessDaysInMonth = function () {
    if (!this.isValid()) return [];
    let s = this.clone().startOf("month");
    const t = this.clone().endOf("month"),
      e = [];
    let n = !1;
    for (; !n;) s.isBusinessDay() && e.push(s.clone()), s = s.add(1, "day"), s.isAfter(t) && (n = !0);
    return e;
  }, t.prototype.businessWeeksInMonth = function () {
    if (!this.isValid()) return [];
    let s = this.clone().startOf("month");
    const t = this.clone().endOf("month"),
      e = [];
    let n = [],
      o = !1;
    for (; !o;) s.isBusinessDay() && n.push(s.clone()), (5 === s.day() || s.isSame(t, "day")) && (e.push(n), n = []), s = s.add(1, "day"), s.isAfter(t) && (o = !0);
    return e;
  };
};
exports.default = _default;